import { styled } from '@/styled-system/jsx';

import { Anchor, Box, Text } from '@zillow/constellation-10';

import SimpleCard from '../components/SimpleCard';

export const EmptyStateTitleText = styled(Text, {
  base: {
    textStyle: 'heading-xs',
    marginBottom: 'tightest',
  },
});

export const EmptyStateBodyText = styled(Text, {
  base: {
    display: 'block',
    marginBottom: 'default',
  },
});

export const NoUnderlineAnchor = styled(Anchor, {
  base: {
    textDecoration: 'none',
    color: 'inherit !important',
  },
});

export const StyledEmptySimpleCard = styled(SimpleCard, {
  base: {
    paddingTop: { base: 'tight', lg: 'loose' },
    paddingInline: { base: 'tight', lg: 'looser' },
    paddingBottom: { base: 'tight', lg: 'looser' },
    borderRadius: 'Card.Root !important',
  },
});

export const StyledEmptyStateContainer = styled(Box, {
  base: {
    textAlign: 'left',
  },
});

export const StyledIconContainer = styled(Box, {
  base: {
    marginBottom: 'default',
  },
});
